// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button {\n  border: 0;\n  border-radius: 10px;\n  color: white;\n  padding: 10px 20px;\n  transition: all 0.3s;\n}\n", "",{"version":3,"sources":["button.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB","file":"button.css","sourcesContent":["button {\n  border: 0;\n  border-radius: 10px;\n  color: white;\n  padding: 10px 20px;\n  transition: all 0.3s;\n}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
